<template>
    <!-- 虚拟奖品用户信息录入弹窗 -->
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        class-name="vertical-center-modal"
        :styles="{top: '100px'}">
        <div class="diyModal">
            <!-- <van-icon name="cross" size="31 " style="font-weight: 400; position: absolute; right: 12px;" @click="isVisibility=false"/> -->
            <!--中奖弹窗背景-->
            <div class="diyModalBg"
                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
                <img :src="diyModalBg[awardObj.bigWheelActivityType-1]">
            </div>
            <!--中奖内容文本-->
            <div class="awardContent">
                <!--大转盘和盲盒-->
                <div v-if="awardObj.bigWheelActivityType != '3'">
                    <div class="awardHead"
                        :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">恭喜您获得</div>
                    <div class="awardName ellipsis"
                        :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">
                        {{ awardObj.goodsName || awardObj.rewardName || awardObj.rightsName }}</div>
                </div>
                <!--轮盘锦鲤-->
                <div v-else>
                    <div class="tiger-head">恭喜您获得</div>
                    <div class="tiger-award-name ellipsis">{{ awardObj.goodsName || awardObj.rewardName }}</div>
                </div>
                <img :src="diyModalHead[awardObj.bigWheelActivityType-1]"
                    style="width: 100%; margin: 5px 0;">
                <div v-if="isGuideFlag || awardObj.isBeneficial">
                    <!-- 1.先处理需要预约导购的 -->
                    <div v-if="awardObj.appointmentFlag === '1'">
                        <!-- 免单抽奖：app和pc下单不需要跳转 -->
                        <div v-if="awardCache && awardCache.collectionType === '4' && ['1','2'].includes(awardCache.drawOrderSource)">
                            <img :src="activationCodeUrl"
                                style="width:200px">
                            <p>免单码：{{ awardCache.activationCode }}</p>
                            <p>免单订单号：{{ awardCache.orderNo }}</p>
                        </div>
                        <div v-else>
                            请预约导购后去门店领取
                        </div>
                    </div>
                    <!-- 2.再处理不需要预约导购的 -->
                    <div v-else>
                        <!-- 免单抽奖：app和pc下单不需要跳转 -->
                        <div v-if="awardCache && awardCache.collectionType === '4' ">
                            <div v-if="['1','2'].includes(awardCache.drawOrderSource)">
                                <img :src="activationCodeUrl"
                                    style="width:200px">
                                <p>免单码：{{ awardCache.activationCode }}</p>
                                <p>免单订单号：{{ awardCache.orderNo }}</p>
                            </div>
                            <div v-else>
                                请预约导购后去门店领取
                            </div>
                        </div>
                        <div v-else>
                            <img :src="activationCodeUrl2"
                                style="width:200px">
                            <p>核销码：{{ awardCache.writeOffCode }}</p>
                        </div>
                    </div>
                    <div v-if="['2','4','3'].includes(awardObj.collectionType) && awardObj.effectiveStartTime && awardObj.effectiveEndTime"
                        class="exp-text">有效期：{{ awardObj.effectiveStartTime.slice(0,10).replace(/-/g,"/") }} -
                        {{ awardObj.effectiveEndTime.slice(0,10).replace(/-/g,"/") }}</div>
                </div>
                <div v-else
                    style="padding: 0 15px;">
                    <!-- 历史数据走这里 -->
                    <div v-if="userInfoList && userInfoList.length === 0">
                        <!-- 顾客姓名 -->
                        <van-cell-group class="group1">
                            <van-field v-model="modelFormCustom.userName"
                                size='large'
                                label-width="65px"
                                label="姓名"
                                @focus="isUserName=true"
                                @blur="isUserName=false"
                                :placeholder="!isUserName?'请输入姓名':''"
                                clearable />
                        </van-cell-group>
                        <!-- 顾客电话 -->
                        <van-cell-group>
                            <van-field v-model="modelFormCustom.userPhone"
                                size='large'
                                label-width="65px"
                                label="电话"
                                @focus="isUserPhone=true"
                                @blur="isUserPhone=false"
                                :placeholder="!isUserPhone?'请输入电话':''"
                                clearable />
                        </van-cell-group>
                    </div>
                    <div v-else>
                        <van-cell-group v-for="(item,index) in userInfoList"
                            :key="index"
                            class="group1">
                            <van-field v-model="item.fieldVal"
                                size="large"
                                label-width="65px"
                                :readonly="isFilledFlag"
                                :label="item.fieldName"
                                :placeholder="item.fieldTips"
                                maxlength='200'
                                clearable />
                        </van-cell-group>
                    </div>
                </div>
                <div v-if="awardObj.singleFlag && awardObj.jumpType === '1' && isGuideFlag"
                    style="text-align: center; color: #999999; margin: 15px 0 0 0;">点击确认返回Hi荣耀首页</div>
            </div>
            <div class="diyReceive">
                <div class="diyModalButton"
                    :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''"
                        src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '4' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <!--虚拟奖品领取方式为免单时，如果订单来源是Hi荣耀小程序(drawOrderSource='3')，则需要跳转小程序预约导购-->
                    <!--虚拟奖品领取方式为线下核销、预约兑卡密时,此时drawOrderSource=null，则需要跳转小程序预约导购-->
                    <div v-if="isGuideFlag && ['3', null].includes(awardCache.drawOrderSource)"
                        class="diyModalButtonText">
                        <!-- 如果不需要预约，点了确认弹框消失，如果需要预约，还要检验有没有到预约时间，到了就预约，没到就提示 -->
                        <div v-if="awardObj.appointmentFlag && awardObj.appointmentFlag === '0'">
                            <!-- 虚拟+核销+无需预约+有下级页面+最后一次抽奖 就是下一步 -->
                            <div v-if="awardObj.singleFlag"
                                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                                @click="nextStep(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                            <div v-else
                                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                                @click="modalCancel(true)">确认</div>
                        </div>
                        <div v-else>
                            <div v-if="errorTime"
                                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                                @click="showErrorMessage()">确认</div>
                            <div v-else>
                                <div :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                                    @click="toShoppingGuide">确认</div>
                                <!-- 跳小程序 -->
                                <!--小程序打开H5时跳转-->
                                <div v-if="miniFlag"
                                    style="width: 200px; height: 45px; position: absolute; top:0;"
                                    @click="backXcx()"></div>
                                <!--微信打开H5时跳转-->
                                <div v-else
                                    style="width: 100%; height: 100%; position: absolute; top: 0;">
                                    <wx-open-launch-weapp :id="'launch-btn'"
                                        :env-version="env"
                                        :username="hiHonorWxAppId"
                                        :path="path">
                                        <script type="text/wxtag-template">
                                            <div style="width: 150px; height: 220px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                                  </script>
                                    </wx-open-launch-weapp>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--虚拟奖品为免单时，如果订单来源是PC或APP(drawOrderSource='1' / '2')，则直接关闭弹窗-->
                    <div v-else-if="['1','2'].includes(awardCache.drawOrderSource)"
                        class="diyModalButtonText">
                        <div v-if="awardObj.appointmentFlag && awardObj.appointmentFlag === '0' && awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="nextStep(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                        <div v-else
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="modalCancel(true)">确认</div>
                    </div>
                    <!--虚拟奖品领取方式为线上兑换-->
                    <div v-else
                        class="diyModalButtonText">
                        <div v-if="isFilledFlag" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="handleConfirm()">确定</div>
                        <div v-else :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="messageHandler()">{{ btnName }}</div>
                    </div>
                </div>
            </div>
            <div class="diyClose"
                @click="modalCancel(true)">
                <van-icon name="close" />
            </div>
        </div>
    </van-dialog>
</template>

<script>
import wx from 'weixin-js-sdk';
import { config as configEnv } from '../../../../../commons/config.js';
import { config } from '@/api/config.js';
import { queryNeedNotifyAwardInfo } from '../../../../../commons/commonJudgeIsNeedNotify.js';
import { Dialog, Cell, CellGroup, Icon, Field, Toast } from 'vant';
import { GoodsType} from '../../../../../commons/commonVariables.js';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Field.name]: Field,
  },
  props: {
    awardObj: Object,
    activityObj: Object,
    referrFlag: String,
    miniFlag: Boolean,
    activityUrl: String,
    // 获取抽奖次数方式
    drawType: String,
    modalButtonText: String,
    userInfoList: Array,
    isFilledFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisibility: false,
      modelFormCustom: {
        userName: '',
        userPhone: '',
      },
      isUserName: false,
      isUserPhone: false,
      isClick: false,
      isGuideFlag: false,
      path: '', //预约导购路径
      diyModalBg: [
        'static/runtime/images/magic/award/diyModalBg.png',
        'static/runtime/images/magic/award/awardBg2.png',
        'static/runtime/images/magic/award/tiger-bj.png',
        'static/runtime/images/magic/award/diyModalBg.png',
      ],
      diyModalHead: [
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
        'static/runtime/images/magic/award/awardBg1.png',
        'static/runtime/images/magic/award/tiger-machine-head-bg.png',
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
      ],
      awardCache: {
        writeOffCode: '',
        activationCode: '',
        collectionType: '',
        drawOrderSource: '',
        writeOffCodeUrl: '',
        writeOffCodeArCode: '',
        orderNo: '',
      },
      activationCodeUrl: '',
      activationCodeUrl2: '',
      errorTime: true,
      errorMessage: '',
      guideId: '', //导购id
      env: configEnv.env !== 'pro' ? 'trial' : 'release', // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
      queryNeedNotityFlag: false, //如果1s内关闭奖品弹窗或者其他操作，则不会查询奖品是否需要订阅到期提醒
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  computed: {
    rewardDescri() {
      if (this.awardObj.rewardDescri) {
        return this.awardObj.rewardDescri.replace(/↵/g, '<br/>').replace(/\n/g, '<br/>');
      } else {
        return '';
      }
    },
    getButtonBgStyle() {
      return {
        background: this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
      };
    },
    btnName() {
      return this.awardObj.rewardType === GoodsType.entityAward ? '提交' : (this.awardObj.isBeneficial ? '领取' : '提交领取');
    },
  },
  watch: {
    'awardObj.extendConfigFlag': function (val) {
      if (!val) {
        if (this.userInfoList && this.userInfoList.length > 0 && this.awardObj.rewardType !== GoodsType.entityAward) {
          this.userInfoList.forEach((item) => {
            item.fieldVal = null;
          });
        } else {
          this.modelFormCustom.userName = '';
          this.modelFormCustom.userPhone = '';
        }
      }
    },
  },
  methods: {
    modalOk() {
      this.queryNeedNotityFlag = false;
      let params = {};
      let obj = {};
      // 历史数据走这里
      if (this.userInfoList && this.userInfoList.length === 0) {
        obj = Object.assign({}, this.modelFormCustom);
        if (!obj.userName) {
          Toast('请输入姓名');
          return false;
        } else if (!obj.userPhone) {
          this.$utils.tips.message('warning', '请输入电话！');
          Toast('请输入电话');
          return false;
        } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
          Toast('请输入正确的电话号码');
          return false;
        }
        if (this.isClick) return;
        this.isClick = true;
        const privacyKeys = {
          userName: '$PrivacyPlain$',
          userPhone: '$PrivacyPlain$',
        };
        //隐私信息保存
        const privacyKeyLsit = [
          {
            userName: 'userName',
            typeText: 'NAME',
            labelText: 'mktMagicShareCpsUserName',
          },
          {
            userPhone: 'userPhone',
            typeText: 'MOBILE_PHONE_NO',
            labelText: 'mktStudentRewardRecodeUserPhone',
          },
        ];
        this.$utils.privacySave(privacyKeys, privacyKeyLsit, obj);
        params = {
          bigwheelRewardRecodeId: this.awardObj.recordId || this.awardObj.bigwheelRewardRecodeId,
          userName: obj.userName,
          userPhone: obj.userPhone,
          referrFlag: this.referrFlag ? this.referrFlag : 0,
        };
        // 配置展示内容走这里
      } else {
        const userInfoList = JSON.parse(JSON.stringify(this.userInfoList));
        const obj = this.userInfoList.find((item) => !item.fieldVal);
        if (obj) {
          Toast(obj.fieldTips);
          return;
        }
        userInfoList.forEach((item) => {
          const privacyObjs = {
            bizObjectId: 'mktExchangeGoodsOthers', //字段名,写死
            channelId: '872cc0ff763db3950176427d145b0332', //固定
            userId: '', //非必填   取登录人
            type: 'OTHERS', //隐私类型
            bizObjectType: 'OTHER',
            opt: '$PrivacySensitized$',
            plainText: item.fieldVal, //明文
          };
          item.fieldVal = privacyObjs;
        });
        if (this.isClick) return;
        this.isClick = true;
        params = {
          bigwheelRewardRecodeId: this.awardObj.recordId || this.awardObj.bigwheelRewardRecodeId,
          userInfoList: userInfoList,
          referrFlag: this.referrFlag ? this.referrFlag : 0,
        };
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/update',
        params: params,
        success: (r) => {
          this.isVisibility = false;
          if(this.awardObj.rewardType === GoodsType.entityAward){
            this.$emit('openReceiveAwardModal');
          } else {
            this.$emit('openVirtualAwardModal');
          }
          this.$emit('refreshRecord');
          setTimeout(() => {
            this.isClick = false;
          }, 10);
        },
        failure: () => {
          setTimeout(() => {
            this.isClick = false;
          }, 10);
        },
      });
    },
    showErrorMessage() {
      Toast(this.errorMessage);
      this.queryNeedNotityFlag = false;
    },
    modalCancel() {
      setTimeout(() => {
        this.isVisibility = false;
        this.queryNeedNotityFlag = false;
      }, 300);
    },
    nextStep(link, type) {
      this.queryNeedNotityFlag = false;
      if (type === '9') {
        if (this.awardCache.collectionType === '4' && ['3', '4'].includes(this.awardCache.drawOrderSource)) {
          wx.miniProgram.navigateTo({
            url: `/${this.path}`,
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        } else {
          this.modalCancel(true);
        }
      }
      this.$emit('nextStep', link, type);
    },
    async openModel(obj) {
      this.isVisibility = true;
      this.queryNeedNotityFlag = true;
      if (this.activityObj.loginType === 'wechat' && this.activityObj.enableMessageNotifications === '1' && obj && obj.businessType) {
        let countDown = 1; //倒计时
        const timerId = setInterval(() => {
          if (countDown === 0) {
            clearInterval(timerId);
            if (this.queryNeedNotityFlag) {
              const params = [
                {
                  goodsType: obj.goodsType, //0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
                  collectionType: obj.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
                  businessId: obj.recordId, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
                  businessType: obj.businessType,
                  goodsId: obj.goodsId,
                  bigWheelActivityType: obj.bigWheelActivityType, // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 => 新盲盒
                  drawWheelType: this.activityObj.drawWheelType, //大转盘抽奖类型 drawWheelType  1 => 普通抽奖   2 => 整点购抽奖   3 => 定时开奖
                },
              ];
              queryNeedNotifyAwardInfo(params, this);
            }
          } else {
            countDown--;
          }
        }, 500);
      }
      // 是否需要预约导购
      if (obj && obj.flag) {
        this.isGuideFlag = obj.flag;
      } else {
        this.isGuideFlag = false;
      }
      if (obj) {
        this.awardCache = obj;
      }
      //校验权益品是否在有效期内
      this.$nextTick(function () {
        this.checkActiveStatus();
      });
      //如果有免单码
      if (this.awardCache) {
        if (this.awardCache.activationCode) {
          this.qrcode(this.awardCache.activationCode);
        }
        if (this.awardCache.writeOffCodeUrl || this.awardCache.writeOffCodeArCode) {
          this.qrcode2(this.awardCache.writeOffCodeUrl || this.awardCache.writeOffCodeArCode);
        }
      }
      if (this.userInfoList && this.userInfoList.length === 0) {
        for (let k in this.modelFormCustom) {
          this.modelFormCustom[k] = '';
        }
      } else {
        if(this.awardObj.rewardType !== GoodsType.entityAward){
          this.userInfoList.forEach((item) => {
            item.fieldVal = null;
          });
        }
      }
      console.log('drwaType', this.drawType);
      if (obj && obj.codeId) {
        let { result } = await this.checkShoppingGuide(obj.codeId);
        this.guideId = result && result.guideId;
        this.path =
          result && result.guideId
            ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
            : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${obj.codeId}&collectionType=${obj.type}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      }
    },
    //跳转hi荣耀预约导购
    toShoppingGuide() {},
    //h5在小程序配置的跳回小程序
    backXcx() {
      this.queryNeedNotityFlag = false;
      let url = `/${this.path}`;
      let jumpH5Flag = '';
      if (!this.guideId) {
        // 预约导购 jumpFromH5Activ 入参区分是从h5跳转
        jumpH5Flag = 'jumpFromH5Activ=1&';
      }
      const index = url.indexOf('?');
      if (index !== -1) {
        const str = url.substring(0, index + 1) + jumpH5Flag + url.substring(index + 1);
        url = str;
      }
      const userBase = sessionStorage.getItem('userInfo');
      console.log(userBase);
      if (!userBase) {
        url += '&refresh=1';
      } else if (!userBase.member) {
        url += '&refresh=1';
      }
      console.log(url);
      sessionStorage.setItem('needRefreshPage', true);
      wx.miniProgram.navigateTo({
        url: url,
        success: function () {
          console.log('跳转回小程序的页面success');
        },
        fail: function (res) {
          console.log('跳转回小程序的页面fail', res);
        },
      });
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    //抽奖免单类型（app，pc）
    qrcode(code) {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: `miniCouponManager/couponCodeShow?couponCode=${code}`,
        params: null,
        success: (r) => {
          let r1 = r.result;
          this.activationCodeUrl = ('data:image/png;base64,' + r1.arCode).replace(/[\r\n]/g, '');
        },
      });
    },
    qrcode2(code) {
      this.activationCodeUrl2 = ('data:image/png;base64,' + code).replace(/[\r\n]/g, '');
    },
    checkActiveStatus() {
      if (this.awardObj.goodsId) {
        const params = {
          goodsId: this.awardObj.goodsId || '', //(权益品id)",
          rewardRecodeId: this.awardObj.bigwheelRewardRecodeId || this.awardObj.rewardRecodeId || this.awardObj.recordId || '', //(中奖记录表id)
          activityCode: this.activityObj.activityCode || '', //活动编码
        };
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketing',
          url: 'h5/bigWheel/getWriteOff',
          params: params,
          success: (r) => {
            console.log(r);
            if (r.code === 200) {
              this.errorTime = false;
            } else {
              this.errorTime = true;
              this.errorMessage = r.message;
            }
          },
        });
      } else {
        this.errorTime = false;
      }
    },
    messageHandler() {
      // 专题活动中奖
      if (this.awardObj.isBeneficial) {
        // 奖品已过期
        if (this.errorTime) {
          this.showErrorMessage();
        } else {
          this.modalCancel(true);
        }
      } else {
        if (this.errorTime) {
          this.showErrorMessage();
        } else {
          this.modalOk();
        }
      }
    },
    // 点击确定处理
    handleConfirm() {
      this.isVisibility = false;
      this.$emit('openReceiveAwardModal');
      this.$emit('refreshRecord');
    }
  },
};
</script>
<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  // height: 120vh;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .diyModal {
      width: 320px;
      // max-width: 694px;
      height: auto;
      margin: auto;
      min-height: 245px;
      padding-bottom: 125px;
      position: relative;
      z-index: 10;
      .tiger-modal-bg {
      }
      .other-modal-bg {
        img {
          height: 210px;
        }
      }
      .diyModalBg {
        width: 100%;
        height: 210px;
        border-radius: 20px;
        overflow: hidden;
        position: absolute;
        bottom: 0px;
        z-index: -1;
        &::before {
          content: '';
          width: 98%;
          height: 150px;
          position: absolute;
          bottom: 1px;
          background: #ffffff;
          border-radius: 26px;
        }
        img {
          width: 100%;
          position: absolute;
          bottom: -1px;
        }
      }
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background: #ffffff;
        text-align: center;
        border-radius: 20px 20px 0 0;
        .tiger-head {
          font-family: HYQiHei-FZS;
          font-size: 16px;
          padding: 26px 0 0;
          color: #29231e;
          font-weight: 400;
        }
        .tiger-award-name {
          color: #29231e;
          font-size: 20px;
          padding: 6px 0 0;
          text-align: center;
          font-weight: 400;
        }
        .awardHead {
          font-size: 16px;
          padding: 26px 0 0;
          color: #2592f7;
        }
        .awardName {
          color: #2592f7;
          font-size: 14px;
          padding: 6px 10px 0;
          text-align: center;
        }
        .group1 {
          &::after {
            border: none;
          }
        }
        .van-cell-group {
          .van-cell--large .van-cell__title {
            font-size: 14px;
          }
        }
      }
      .tiger-btn {
        font-family: HYQiHei-EES;
        color: #d7324c;
        font-size: 18px;
      }
      .diyReceive {
        width: 100%;
        height: 124px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .tiger-btn-img {
          width: 90% !important;
          height: 80% !important;
        }
        .diyModalButton,
        .blindBoxBtn {
          width: 200px;
          height: 45px;
          margin-top: 33px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          position: relative;
          img,
          .diyModalButtonBg {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .diyModalButtonBg {
            background: #ffffff;
            border-radius: 36px;
          }
          .diyModalButtonText {
            width: 100%;
            height: 100%;
            position: absolute;
            div {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }

        .blindBoxBtn {
          color: #b27d13 !important;
          font-size: 16px;
          height: 36px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}

.copy {
  color: #2592f7;
  border: 1px solid #2592f7;
  text-align: center;
  line-height: 28px;
  padding: 2px 10px 1px;
  border-radius: 15px;
  font-size: 12px;
  margin-left: 5px;
}
.defaultGray {
  color: #666666;
}

.noBorder input,
.noBorder textarea {
  border: none;
  outline: none;
}
.noBorder input:focus,
.noBorder input:hover,
.noBorder textarea:focus,
.noBorder textarea:hover {
  box-shadow: none;
  border: none;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/virtualizedAwardModal.vue